export default {
  // Common/shared strings
  common: {
    save: 'Tallenna',
    cancel: 'Peruuta',
    delete: 'Poista',
    edit: 'Muokkaa',
    add: 'Lisää',
    create: 'Luo',
    update: 'Päivitä',
    close: 'Sulje',
    search: 'Haku',
    filter: 'Suodata',
    loading: 'Ladataan...',
    saving: 'Tallennetaan...',
    deleting: 'Poistetaan...',
    error: 'Virhe',
    success: 'Onnistui',
    confirm: 'Vahvista',
    yes: 'Kyllä',
    no: 'Ei',
    back: 'Takaisin',
    next: 'Seuraava',
    previous: 'Edellinen',
    all: 'Kaikki',
    none: 'Ei mitään',
    select: 'Valitse',
    required: 'Pakollinen',
    optional: 'Valinnainen',
    actions: 'Toiminnot',
    status: 'Tila',
    name: 'Nimi',
    description: 'Kuvaus',
    date: 'Päivämäärä',
    time: 'Aika',
    type: 'Tyyppi',
    noResults: 'Ei tuloksia',
    showMore: 'Näytä lisää',
    showLess: 'Näytä vähemmän',
  },

  // Authentication
  auth: {
    login: 'Kirjaudu sisään',
    logout: 'Kirjaudu ulos',
    register: 'Rekisteröidy',
    email: 'Sähköposti',
    password: 'Salasana',
    confirmPassword: 'Vahvista salasana',
    forgotPassword: 'Unohditko salasanan?',
    resetPassword: 'Nollaa salasana',
    newPassword: 'Uusi salasana',
    currentPassword: 'Nykyinen salasana',
    rememberMe: 'Muista minut',
    loginSubtitle: 'Kirjaudu jatkaaksesi tehtävien parissa',
    sessionExpired: 'Istunto vanhentunut',
    sessionExpiredMessage: 'Kirjaudu uudelleen jatkaaksesi.',
    loginToAccept: 'Kirjautumalla hyväksyt palvelun',
    termsOfService: 'käyttöehdot',
    and: 'ja',
    privacyPolicy: 'tietosuojakäytännön',
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    phone: 'Puhelin',
    loggingIn: 'Kirjaudutaan...',
    invalidCredentials: 'Virheellinen sähköposti tai salasana',
    accountLocked: 'Tili lukittu',
    passwordResetSent: 'Salasanan nollauslinkki lähetetty',
    passwordChanged: 'Salasana vaihdettu',
  },

  // Settings
  settings: {
    title: 'Asetukset',
    language: 'Kieli',
    languageFinnish: 'Suomi',
    languageEnglish: 'English',
    notifications: 'Ilmoitukset',
    emailNotifications: 'Sähköposti-ilmoitukset',
    pushNotifications: 'Push-ilmoitukset',
    theme: 'Teema',
    darkMode: 'Tumma tila',
    lightMode: 'Vaalea tila',
    profile: 'Profiili',
    account: 'Tili',
    security: 'Turvallisuus',
    privacy: 'Yksityisyys',
    mySettings: 'Omat asetukset',
    changePassword: 'Vaihda salasana',
    bottomNavigation: 'Alapalkin pikavalinnat',
  },

  // Navigation
  nav: {
    home: 'Etusivu',
    devices: 'Laitteet',
    tasks: 'Tehtävät',
    projects: 'Projektit',
    reports: 'Raportit',
    admin: 'Hallinta',
    settings: 'Asetukset',
    profile: 'Profiili',
    help: 'Ohje',
    qms: 'QMS',
    training: 'Koulutukset',
    repairs: 'Korjaukset',
    hourReporting: 'Tuntikirjaus',
    diary: 'Päiväkirja',
  },

  // Devices
  devices: {
    title: 'Laitteet',
    device: 'Laite',
    addDevice: 'Lisää laite',
    editDevice: 'Muokkaa laitetta',
    deleteDevice: 'Poista laite',
    deviceName: 'Laitteen nimi',
    deviceType: 'Laitetyyppi',
    serialNumber: 'Sarjanumero',
    location: 'Sijainti',
    department: 'Osasto',
    status: 'Tila',
    active: 'Aktiivinen',
    inactive: 'Ei käytössä',
    maintenance: 'Huollossa',
    retired: 'Poistettu käytöstä',
    lost: 'Kadonnut',
    lastInspection: 'Viimeisin tarkastus',
    nextInspection: 'Seuraava tarkastus',
    manufacturer: 'Valmistaja',
    model: 'Malli',
    yearOfManufacture: 'Valmistusvuosi',
    purchaseDate: 'Hankintapäivä',
    warrantyExpires: 'Takuu päättyy',
    notes: 'Muistiinpanot',
    attachments: 'Liitteet',
    history: 'Historia',
    faults: 'Viat',
    trainings: 'Koulutukset',
    noDevices: 'Ei laitteita',
    searchDevices: 'Hae laitteita...',
    filterByStatus: 'Suodata tilan mukaan',
    filterByType: 'Suodata tyypin mukaan',
    filterByDepartment: 'Suodata osaston mukaan',
    map: 'Kartta',
    list: 'Lista',
    kanban: 'Kanban',
  },

  // Admin
  admin: {
    title: 'Hallintapaneeli',
    users: 'Käyttäjät',
    roles: 'Roolit',
    trainings: 'Koulutukset',
    certifications: 'Sertifikaatit',
    templates: 'Mallipohjat',
    departments: 'Osastot',
    announcements: 'Tiedotteet',
    hourReporting: 'Tuntikirjaus',
    diary: 'Päiväkirja',
    qms: 'QMS',
    documents: 'Dokumentit',
    invoicing: 'Laskutus',
    superadmin: 'Superadmin',
    settings: 'Asetukset',
    dashboard: 'Dashboard',
    tasks: 'Tehtävät',
    infoTV: 'InfoTV',
    cards: 'Kortit',
  },

  // Users
  users: {
    title: 'Käyttäjät',
    user: 'Käyttäjä',
    addUser: 'Lisää käyttäjä',
    editUser: 'Muokkaa käyttäjää',
    deleteUser: 'Poista käyttäjä',
    email: 'Sähköposti',
    name: 'Nimi',
    role: 'Rooli',
    department: 'Osasto',
    jobRole: 'Ammatti',
    status: 'Tila',
    active: 'Aktiivinen',
    inactive: 'Ei käytössä',
    lastLogin: 'Viimeisin kirjautuminen',
    createdAt: 'Luotu',
    noUsers: 'Ei käyttäjiä',
    searchUsers: 'Hae käyttäjiä...',
    inviteUser: 'Kutsu käyttäjä',
    resendInvite: 'Lähetä kutsu uudelleen',
    actions: 'Toiminnot',
    cards: 'Kortit',
  },

  // Roles & Permissions
  roles: {
    title: 'Roolit',
    role: 'Rooli',
    addRole: 'Lisää rooli',
    editRole: 'Muokkaa roolia',
    deleteRole: 'Poista rooli',
    roleName: 'Roolin nimi',
    permissions: 'Oikeudet',
    description: 'Kuvaus',
    admin: 'Ylläpitäjä',
    user: 'Käyttäjä',
    viewer: 'Katsoja',
    noRoles: 'Ei rooleja',
  },

  // Trainings
  trainings: {
    title: 'Koulutukset',
    training: 'Koulutus',
    addTraining: 'Lisää koulutus',
    editTraining: 'Muokkaa koulutusta',
    deleteTraining: 'Poista koulutus',
    trainingName: 'Koulutuksen nimi',
    validityPeriod: 'Voimassaoloaika',
    months: 'kuukautta',
    required: 'Pakollinen',
    optional: 'Valinnainen',
    completed: 'Suoritettu',
    expired: 'Vanhentunut',
    expiring: 'Vanhenemassa',
    valid: 'Voimassa',
    noTrainings: 'Ei koulutuksia',
    completeTraining: 'Suorita koulutus',
    renewTraining: 'Uusi koulutus',
    certificate: 'Todistus',
  },

  // QMS (Quality Management System)
  qms: {
    title: 'Laatujärjestelmä',
    nonconformance: 'Poikkeama',
    nonconformances: 'Poikkeamat',
    addNonconformance: 'Lisää poikkeama',
    risk: 'Riski',
    risks: 'Riskit',
    document: 'Dokumentti',
    documents: 'Dokumentit',
    audit: 'Auditointi',
    audits: 'Auditoinnit',
    corrective: 'Korjaava toimenpide',
    preventive: 'Ehkäisevä toimenpide',
    status: 'Tila',
    open: 'Avoin',
    inProgress: 'Käsittelyssä',
    closed: 'Suljettu',
    severity: 'Vakavuus',
    low: 'Matala',
    medium: 'Keskitaso',
    high: 'Korkea',
    critical: 'Kriittinen',
  },

  // Hour Reporting
  hours: {
    title: 'Tuntikirjaus',
    addEntry: 'Lisää kirjaus',
    date: 'Päivämäärä',
    hours: 'Tunnit',
    project: 'Projekti',
    task: 'Tehtävä',
    description: 'Kuvaus',
    totalHours: 'Tunnit yhteensä',
    thisWeek: 'Tällä viikolla',
    thisMonth: 'Tässä kuussa',
    approve: 'Hyväksy',
    reject: 'Hylkää',
    pending: 'Odottaa',
    approved: 'Hyväksytty',
    rejected: 'Hylätty',
  },

  // Projects & Tasks
  projects: {
    title: 'Projektit',
    project: 'Projekti',
    addProject: 'Lisää projekti',
    editProject: 'Muokkaa projektia',
    task: 'Tehtävä',
    tasks: 'Tehtävät',
    addTask: 'Lisää tehtävä',
    assignee: 'Vastuuhenkilö',
    dueDate: 'Määräaika',
    priority: 'Prioriteetti',
    low: 'Matala',
    medium: 'Normaali',
    high: 'Korkea',
    urgent: 'Kiireellinen',
    status: 'Tila',
    todo: 'Tehtävä',
    inProgress: 'Käynnissä',
    done: 'Valmis',
  },

  // Reports
  reports: {
    title: 'Raportit',
    generate: 'Luo raportti',
    export: 'Vie',
    exportExcel: 'Vie Excel',
    exportPDF: 'Vie PDF',
    dateRange: 'Aikaväli',
    from: 'Alkaen',
    to: 'Päättyen',
    today: 'Tänään',
    thisWeek: 'Tämä viikko',
    thisMonth: 'Tämä kuukausi',
    thisYear: 'Tämä vuosi',
    custom: 'Mukautettu',
  },

  // Errors
  errors: {
    generic: 'Tapahtui virhe',
    networkError: 'Verkkovirhe',
    notFound: 'Ei löytynyt',
    unauthorized: 'Ei oikeuksia',
    forbidden: 'Pääsy estetty',
    serverError: 'Palvelinvirhe',
    validationError: 'Tarkista syötteet',
    requiredField: 'Pakollinen kenttä',
    invalidEmail: 'Virheellinen sähköposti',
    invalidPhone: 'Virheellinen puhelinnumero',
    passwordTooShort: 'Salasana on liian lyhyt',
    passwordsDoNotMatch: 'Salasanat eivät täsmää',
    tryAgain: 'Yritä uudelleen',
    contactSupport: 'Ota yhteyttä tukeen',
  },

  // Confirmations
  confirm: {
    delete: 'Haluatko varmasti poistaa?',
    deleteItem: 'Haluatko varmasti poistaa kohteen "{name}"?',
    unsavedChanges: 'Sinulla on tallentamattomia muutoksia. Haluatko poistua?',
    logout: 'Haluatko kirjautua ulos?',
    irreversible: 'Tätä toimintoa ei voi perua.',
  },

  // Time & Dates
  time: {
    today: 'Tänään',
    yesterday: 'Eilen',
    tomorrow: 'Huomenna',
    now: 'Nyt',
    ago: 'sitten',
    in: 'kuluttua',
    minutes: 'minuuttia',
    hours: 'tuntia',
    days: 'päivää',
    weeks: 'viikkoa',
    months: 'kuukautta',
    years: 'vuotta',
  },

  // Notifications
  notifications: {
    title: 'Ilmoitukset',
    markAllRead: 'Merkitse kaikki luetuiksi',
    noNotifications: 'Ei ilmoituksia',
    newNotification: 'Uusi ilmoitus',
  },

  // File handling
  files: {
    upload: 'Lataa tiedosto',
    download: 'Lataa',
    delete: 'Poista tiedosto',
    preview: 'Esikatselu',
    noFiles: 'Ei tiedostoja',
    dragAndDrop: 'Vedä ja pudota tiedostoja tähän',
    orClickToUpload: 'tai klikkaa valitaksesi',
    maxSize: 'Maksimikoko',
    allowedTypes: 'Sallitut tyypit',
    uploadError: 'Lataus epäonnistui',
    uploadSuccess: 'Lataus onnistui',
  },
};
